/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Input.Mouse
 */

/* eslint-disable */
module.exports = {

    MouseManager: require('./MouseManager')
       
};
/* eslint-enable */



//////////////////
// WEBPACK FOOTER
// ./input/mouse/index.js
// module id = 791
// module chunks = 0